import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import { Button, FormControl, Input, Heading, Text, Alert, Stack } from '@/components/lib'
import useStore from '../../store'
import api from '../../api'
import utils from '../../utils/utils'

import Terms from '../includes/Terms'
import EntryContainer from '../includes/EntryContainer'
import useTitle from '../../hooks/useTitle'

export default function Enrol () {
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [password, setPassword] = useState('')
  const [termsAgreed, setTermsAgreed] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState()
  const navigate = useNavigate()
  const store = useStore()
  useTitle('Enrol')

  function enrol () {
    if (!password || !termsAgreed) {
      return setError('Please ensure you have set a password and agreed to the terms.')
    }
    setError(null)
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')
    setLoading(true)
    api.accounts.enrol(token, firstName, lastName, password, termsAgreed, (authToken) => {
      setLoading(false)
      store.completeLogin(authToken)
      utils.toast('success', 'Password set successfully.')
      navigate('/')
    }, (err) => {
      setLoading(false)
      setError(err.message)
      utils.toast('error', 'Unable to enrol your account', err.message)
    })
  }

  return (
    <EntryContainer>
      <Stack spacing={5} maxW='600px'>
        <Alert status='info' variant='left-accent' rounded='md' shadow='md'>
          <Text>You're on this page because someone has invited you to join a team on Trialflare.</Text>
        </Alert>

        <Heading size='lg'>Set-up your Trialflare account</Heading>
        <Heading size='sm'>Your account is nearly ready. We just need a bit more info.</Heading>

        <FormControl label='Your first name' helperText='This is to enable others in your team to identify you.'>
          <Input autoFocus id='firstName' placeholder='Jane' aria-describedby='name-helper-text' value={firstName} onChange={e => setFirstName(e.target.value)} />
        </FormControl>
        <FormControl label='Your last name'>
          <Input id='lastName' placeholder='Doe' value={lastName} onChange={e => setLastName(e.target.value)} />
        </FormControl>
        <FormControl label='A password for your account' helperText='This needs to be at least 8 characters long.'>
          <Input id='password' placeholder='Enter a secure password...' type='password' value={password} onChange={e => setPassword(e.target.value)} aria-describedby='password-helper-text' />
        </FormControl>
        <Terms value={termsAgreed} onChange={setTermsAgreed} />

        {error &&
          <Alert status='error' withIcon title='There was a problem'>
            <Text>{error}</Text>
          </Alert>}

        <Button disabled={!password || !termsAgreed} colorPalette='primary' onClick={enrol} isLoading={loading}>Complete Setup</Button>
      </Stack>
    </EntryContainer>
  )
}
